import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Button, Box, Card, CardContent, Typography } from '@mui/material';
import axios from 'axios';
import swal from 'sweetalert';

const WorkshopReportMoreDetails = (props) => {
    const id = props.match.params.id; // Extract ID from props
    const history = useHistory();
    const eventid = localStorage.getItem('eventid');
    const [workshopDetails, setWorkshopDetails] = useState(null);
    const [participants, setParticipants] = useState([]); // Initialize as empty array
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1); // Current page
    const [showAll, setShowAll] = useState(false); // State to toggle showing all participants
    const participantsPerPage = 10; // Number of participants to show per page
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code_two: ""
    });
    useEffect(() => {
        // Fetch workshop details from API
        const fetchWorkshopDetails = async () => {
            try {
                const response = await axios.get(`api/workshop-participnat-report/${id}/${eventid}`);
                if (response.status === 200) {
                    setWorkshopDetails(response.data.workshop || {});
                    setParticipants(response.data.participants || []); // Adjust based on API response
                } else {
                    swal('Error', 'Failed to fetch workshop details', 'error');
                }
            } catch (error) {
                console.error('API Error:', error);
                swal('Error', 'An error occurred while fetching workshop details', 'error');
            } finally {
                setLoading(false);
            }
        };

        fetchWorkshopDetails();
    }, [id]);

     useEffect(() => {
        const fetchHomeSetup = async () => {
            try {
                const res = await axios.get(`api/add-home-setup-index?id=${eventid}`);
                if (res.status === 200) {
                    setAbstractHomeSetup(res.data.HomePageSetup);
                } else {
                    swal('Error', 'Failed to fetch home setup data', 'error');
                }
            } catch (error) {
                console.error('API Error:', error);
                swal('Error', 'An error occurred while fetching home setup data', 'error');
            } finally {
                setLoading(false);
            }
        };

        fetchHomeSetup();
    }, [eventid]); // Fetch data whenever eventid changes

    if (loading) {
        return <Typography variant="h6">Loading...</Typography>;
    }

    if (!workshopDetails) {
        return <Typography variant="h6">No details found for this workshop.</Typography>;
    }

    // Calculate total pages
    const totalPages = Math.ceil(participants.length / participantsPerPage);

    // Get current participants for the page
    const indexOfLastParticipant = currentPage * participantsPerPage;
    const indexOfFirstParticipant = indexOfLastParticipant - participantsPerPage;
    const currentParticipants = showAll ? participants : participants.slice(indexOfFirstParticipant, indexOfLastParticipant);

    const downloadCSV = () => {
        const csvData = [];

        // Add an empty row above the workshop name
        csvData.push('');

        // Add workshop name as the first row, with extra blank cells for merging effect
        const workshopRow = Array(4).fill(''); // Adjust the number for more columns
        workshopRow[1] = workshopDetails.workshop_name; // Centered text in the second cell
        csvData.push(workshopRow.join(','));

        // Add an empty row below the workshop name
        csvData.push('');

        // Add headers
        const headers = ['QrCodeID', 'Name', 'Email', 'Contact No'];
        csvData.push(headers.join(','));

        // Add participant data
        participants.forEach((participant) => {
            const row = [
                participant.id,
                participant.particent_name,
                participant.particent_email,
                participant.particent_phone_number
            ];
            csvData.push(row.join(','));
        });

        const csvString = csvData.join('\n');
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', 'participants.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const backGroundButtonByEvent = abstractHomeSetup.color_code_two || '#145348';

    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', marginTop: '5%' }}>
                <Box display="flex" justifyContent="flex-end" mt={2}>
                <Button
                        variant="contained"
                        style={{ marginLeft: '10px' , backgroundColor: backGroundButtonByEvent,
                            ":hover": { color: "white" } }}
                        onClick={downloadCSV}
                        // Space between buttons
                    >
                        Download CSV
                    </Button>
                    <Button
                        variant="contained"
                        
                        onClick={() => history.goBack()}
                        style={{ marginLeft: '10px' , backgroundColor: backGroundButtonByEvent,
                            ":hover": { color: "white" } }}
                        
                    >
                        Back
                    </Button>
                    
                </Box>
                <Card sx={{ width: '60vw', margin: 'auto' }}>
                    <CardContent>
                        <Typography component="h1" variant="h5">
                            Workshop Details
                        </Typography>
                        <Typography variant="h6" gutterBottom>
                            Workshop Name: {workshopDetails.workshop_name}
                        </Typography>
                        <Typography variant="body1">
                            Event Name: {workshopDetails.event_name}
                        </Typography>
                        <Typography variant="body1">
                            Total Seats: {workshopDetails.workshop_no_ofseats}
                        </Typography>
                        <Typography variant="body1">
                            Booked Seats: {participants.length}
                        </Typography>


                        {/* Render participants if available */}
                      

                        <Box mt={4}>
                            <Typography variant="h6">Participants:</Typography>
                            {currentParticipants.length > 0 ? (
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ border: '1px solid #ddd', padding: '8px' }}>No</th>
                                            <th style={{ border: '1px solid #ddd', padding: '8px' }}>QrCodeID</th>
                                            <th style={{ border: '1px solid #ddd', padding: '8px' }}>Name</th>
                                            <th style={{ border: '1px solid #ddd', padding: '8px' }}>Email</th>
                                            <th style={{ border: '1px solid #ddd', padding: '8px' }}>Contact No</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentParticipants.map((participant, index) => (
                                            <tr key={index}>
                                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                                    {index + 1 + (showAll ? 0 : indexOfFirstParticipant)} {/* Adjusted for pagination */}
                                                </td>
                                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                                    {participant.id}
                                                </td>
                                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                                    {participant.particent_name}
                                                </td>
                                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                                    {participant.particent_email}
                                                </td>
                                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                                    {participant.particent_phone_number}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : (
                                <Typography variant="body1">No participants found.</Typography>
                            )}
                        </Box>
                        {/* Pagination Controls */}
                        <Box display="flex" justifyContent="center" mt={3}>
                            <Button
                                variant="contained"
                                onClick={() => setShowAll(prev => !prev)} // Toggle show all
                                style={{ marginRight: '10px'  , backgroundColor: backGroundButtonByEvent}}
                            >
                                {showAll ? 'Show Less' : 'Show All'}
                            </Button>
                            {!showAll && (
                                <>
                                    <Button
                                        variant="contained"
                                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                        disabled={currentPage === 1}
                                        
                                    >
                                        Previous
                                    </Button>
                                    <Typography variant="body1" style={{ margin: '0 10px' }}>
                                        Page {currentPage} of {totalPages}
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                        disabled={currentPage === totalPages}
                                    >
                                        Next
                                    </Button>
                                </>
                            )}
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
};

export default WorkshopReportMoreDetails;
